import type { MessageDescriptor } from 'react-intl'
import { defineMessage, defineMessages } from 'react-intl'

export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS = 7_500
export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS = 100

/** Display priority */
export const campaignDisplayPriority: Record<App.LoyaltyBonusPointsCampaignType, number> = {
  double_status_credits: 3,
  static: 2,
  triple: 1,
  double: 0,

}

const campaignLabelMessages = defineMessages({
  static: {
    id: '46Kc2-OXvP2ZiSjsiIUS',
    defaultMessage: 'Bonus points',
  },
  double: {
    id: 'e3qJEmGkvjsfonqDtflC',
    defaultMessage: 'Double points',
  },
  doubleStatusCredits: {
    id: 'jPC2qTXEKzZI4DeXyc2-',
    defaultMessage: 'Double status credits',
  },
  triple: {
    id: '94stKKOxUQbIM49w5n4n',
    defaultMessage: 'Triple points',
  },
})

export const LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL: Record<App.LoyaltyBonusPointsCampaignType, MessageDescriptor> = {
  static: campaignLabelMessages.static,
  double: campaignLabelMessages.double,
  double_status_credits: campaignLabelMessages.doubleStatusCredits,
  triple: campaignLabelMessages.triple,
}

const campaignPromotionMessages = defineMessages({
  static: {
    id: '1bzJA2_-PxNzqNW1d1XA',
    defaultMessage: 'This includes a bonus points promotion.',
  },
  double: {
    id: 'coB4q9OOvKkJKxqNzQUN',
    defaultMessage: 'This includes a double bonus points promotion.',
  },
  triple: {
    id: 'b99yfpv2tCN31IqmJ8Qs',
    defaultMessage: 'This includes a triple bonus points promotion.',
  },
  doubleStatusCredits: {
    id: 'yFlbskfkha4vW_eDRp-i',
    defaultMessage: 'This includes a double status credits promotion.',
  },
})

export const LOYALTY_BONUS_POINTS_PROMOTION_MESSAGE: Record<App.LoyaltyBonusPointsCampaignType, MessageDescriptor> = {
  static: campaignPromotionMessages.static,
  double: campaignPromotionMessages.double,
  triple: campaignPromotionMessages.triple,
  double_status_credits: campaignPromotionMessages.doubleStatusCredits,
}

const campaignInfoModalMessages = defineMessages({
  static: {
    id: 'l2ddLORSv3ghpJWe9QLK',
    defaultMessage: 'This offer includes bonus Société Points for a limited-time.',
  },
  double: {
    id: 'YEjrhp1nJ-BL7IuaJslC',
    defaultMessage: 'This offer includes double bonus Société Points for a limited-time.',
  },
  triple: {
    id: 'AIjeHFmMIw8ulI0RLN4H',
    defaultMessage: 'This offer includes triple bonus Société Points for a limited-time.',
  },
  doubleStatusCredits: {
    id: 'YIMd4BWVlx17t3rvpr2R',
    defaultMessage: 'This offer includes double bonus Status Credits for a limited-time.',
  },
})

const campaignInfoModalMessagesWithEndDate = defineMessages({
  static: {
    id: 'DOXMCVYzJutEmNE025ww',
    defaultMessage: '<bold>This offer includes bonus Société Points for a limited-time.</bold> Valid until {date}.',
  },
  double: {
    id: 'bx5au5FLTUAQ9xn0HgZL',
    defaultMessage: '<bold>This offer includes double bonus Société Points for a limited-time.</bold> Valid until {date}.',
  },
  triple: {
    id: '292vcsYTlXZkq6HUc9dR',
    defaultMessage: '<bold>This offer includes triple bonus Société Points for a limited-time.</bold> Valid until {date}.',
  },
  doubleStatusCredits: {
    id: 'aGM1DWqe4BXyRrAnN0RO',
    defaultMessage: '<bold>This offer includes double bonus Status Credits for a limited-time.</bold> Valid until {date}.',
  },
})

export const LOYALTY_BONUS_POINTS_INFO_MODAL_MESSAGE: Record<App.LoyaltyBonusPointsCampaignType, MessageDescriptor> = {
  static: campaignInfoModalMessages.static,
  double: campaignInfoModalMessages.double,
  triple: campaignInfoModalMessages.triple,
  double_status_credits: campaignInfoModalMessages.doubleStatusCredits,
}

export const LOYALTY_BONUS_POINTS_INFO_MODAL_MESSAGE_WITH_END_DATE: Record<App.LoyaltyBonusPointsCampaignType, MessageDescriptor> = {
  static: campaignInfoModalMessagesWithEndDate.static,
  double: campaignInfoModalMessagesWithEndDate.double,
  triple: campaignInfoModalMessagesWithEndDate.triple,
  double_status_credits: campaignInfoModalMessagesWithEndDate.doubleStatusCredits,
}

export const PAYPAL_TRIPLE_POINTS_CUSTOM_RULE_NAME = 'PayPal 3x Points'

export interface LoyaltyNamedBonusCampaign {
  checkoutSummaryPillMessage?: MessageDescriptor
}

export const LOYALTY_NAMED_BONUS_CAMPAIGNS: Record<string, LoyaltyNamedBonusCampaign> = {
  [PAYPAL_TRIPLE_POINTS_CUSTOM_RULE_NAME]: {
    checkoutSummaryPillMessage: defineMessage({
      id: '-edqSc91RZjhqlxwSykk',
      defaultMessage: 'Includes {bonusPoints} bonus points with {paymentMethodName}',
    }),
  },
}
